<div
  [attr.data-cy-specific-window-name]="name"
  [ngClass]="[!isModal ? 'iu-specific-window-container' : '', 'iu-specific-window']">
  @if (!isModal && isLoading) {
    <p-progressBar [mode]="'indeterminate'" [showValue]="false" [styleClass]="'loading-progressbar'" [value]="0" />
  }
  <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
    <div class="fields">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4 p-grid"><ng-template #left /></div>
        <div class="p-col-12 p-md-4 p-lg-4 p-grid"><ng-template #middle /></div>
        <div class="p-col-12 p-md-4 p-lg-4 p-grid"><ng-template #right /></div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-grid">
          <ng-template #bot />
        </div>
        <ng-template iuDynamicContainer />
      </div>
    </div>

    <div class="iu-specific-btn-container" [ngClass]="[shouldAddPadding ? 'shouldAddPadding' : '']">
      <ng-template #vcrButtons />
      @if (isModal) {
        <iu-button-ui
          btnType="alert"
          class="p-col-12 p-md-3 p-lg-1"
          icon="fa fa-ban"
          label="{{ 'process.cancel' | translate }}"
          (click)="$event.preventDefault(); $event.stopPropagation(); closeModalEmitter.emit()" />
      }
    </div>
  </p-scrollPanel>
</div>
<!-- @if (displaySearch) {
  <iu-modal-ui
    data-cy="search-panel"
    [attr.data-cy-columnName]="this.searchLinkedComponent.autoComplete.data.columnName"
    [title]="this.searchLinkedComponent.autoComplete.label"
    [hasCloseBtn]="true"
    (closeModalEmitter)="displaySearch = false">
    <div class="autocomplete-universal-filter">
      <iu-universal-filter-ui
        [tabId]="-1"
        [columns]="searchLinkedComponent.autoComplete.data.searchColumns"
        [gridTab]="gridTab" />
    </div>
    <iu-grid-tab-infinity-scroll-ui
      #gridTab
      (searchEmitter)="this.searchLinkedComponent.setSearchSelectItem($event); displaySearch = false"
      [data]="this.searchLinkedComponent.autoComplete.data"
      [container]="this"
      [isSearch]="true"
      [dataStored]="this.searchLinkedComponent.autoComplete.dataStored" />
  </iu-modal-ui>
} -->
<div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
  <iu-modal-ui
    [isModalDisplay]="displayFormUI"
    [title]="specificWindowTitle"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false }})">
    <ng-template #vcrSpecific />
  </iu-modal-ui>
</div>
